import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaTrashAlt, FaEdit, FaLock, FaLockOpen } from "react-icons/fa";

import api from "../../services/api";

//alerta
import Notification from "../../components/Notification/Notification";
import ConfirmDialog from "../../components/Notification/ConfirmDialog";
import Table from "../../components/Table";

export default function UserList() {
  // Permissão do usuário no sistema
  let userPermission;
  switch (localStorage.getItem("Permission")) {
    case "Admin":
      userPermission = "admin";
      break;
    case "Controlador":
      userPermission = "manager";
      break;
    case "Executor":
      userPermission = "executor";
      break;
    default:
      break;
  }

  const navigate = useNavigate();

  // States
  const [users, setUsers] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    title: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  // Função para deletar um usuário
  const handleDeleteUser = useCallback(
    async (id, userPermission) => {
      try {
        await api.delete(`${userPermission}/users/${id}`);
        //alert(`Usuário deletado com sucesso.`);
        setNotify({
          isOpen: true,
          message: "Usuário deletado com sucesso.",
          type: "error",
          title: "Deletado",
        });

        setRefresh(true);
        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });
      } catch (err) {
        //alert('Erro ao deletar usuário, tente novamente');
        setNotify({
          isOpen: true,
          message: "Erro ao deletar usuário, tente novamente.",
          type: "error",
          title: "Erro",
        });
      }
    },
    [confirmDialog]
  );

  // chama o alerta para deletar
  const deleteUserDialog = useCallback(
    (id, name, userPermission) => {
      setConfirmDialog({
        isOpen: true,
        title: `Você gostaria de deletar o usuário ${name}?`,
        subTitle: "Esta ação não poderá ser desfeita",
        onConfirm: () => {
          handleDeleteUser(id, userPermission);
        },
      });
    },
    [handleDeleteUser]
  );

  const handleActive = (id, name) => {
    setConfirmDialog({
      isOpen: true,
      title: `Você gostaria de desativar o usuário ${name}?`,
      subTitle: "Você pode ativar posteriormente",
      onConfirm: () => {
        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });

        api.put(`/admin/inactivate/${id}`).then((response) => {
          const newUser = users.map((user) => {
            if (user.id === id) return { ...user, isActive: false };
            return user;
          });

          setUsers(newUser);
        });
      },
    });
  };

  const handleDesactive = (id, name) => {
    setConfirmDialog({
      isOpen: true,
      title: `Você gostaria de reativar o usuário ${name}?`,
      subTitle: "Você pode desativar posteriormente",
      onConfirm: () => {
        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });

        api.put(`/admin/activate/${id}`).then((response) => {
          const newUser = users.map((user) => {
            if (user.id === id) return { ...user, isActive: true };
            return user;
          });

          setUsers(newUser);
        });
      },
    });
  };

  // useEffect
  useEffect(() => {
    if (refresh === true) {
      api
        .get(
          `${userPermission}/users?filter={"where":{"or":[{"role":"Admin"}, {"role":"Controlador"}, {"role":"Executor"}]}}`
        )
        .then((response) => {
          setUsers(response.data);
        });
    }
    setRefresh(false);
    // pega todos os usuários cadastrados
  }, [refresh]);

  const inactive = ({ row }) => {
    if (row.original.role.toLowerCase() === "admin") return <></>;

    return row.original.isActive === false ? (
      <Link
        to={"#"}
        onClick={() => handleDesactive(row.original.id, row.original.name)}
        style={{ textAlign: "center", width: "100%", display: "block" }}
      >
        <FaLock size={20} color="#cf142b" />
      </Link>
    ) : (
      <Link
        to={"#"}
        onClick={() => handleActive(row.original.id, row.original.name)}
        style={{ textAlign: "center", width: "100%", display: "block" }}
      >
        <FaLockOpen size={20} color="#1351B4" />
      </Link>
    );
  };

  /* Colunas da tabela */
  const columns = useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "name",
      },
      {
        Header: "E-mail",
        accessor: "email",
      },
      {
        Header: "Telefone",
        accessor: "telefone",
      },
      {
        Header: "Perfil",
        accessor: "role",
      },
      {
        // Make an expander cell
        Header: () => (
          <div style={{ textAlign: "center", width: "100%" }}>Inativar</div>
        ), // No header
        id: "active ", // It needs an ID
        Cell: inactive,
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: "edit", // It needs an ID
        Cell: ({ row }) => (
          <FaEdit
            size={20}
            color="#1351B4"
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(`/useredit/${row.original.id}`, {
                state: {
                  from: [
                    { name: "Cadastro de Usuário", href: "/userregister" },
                  ],
                },
              })
            }
          />
        ),
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: "expander", // It needs an ID
        Cell: ({ row }) => (
          <Link to="#">
            <FaTrashAlt
              size={20}
              color="#1351B4"
              onClick={() => {
                deleteUserDialog(
                  row.original.id,
                  row.original.name,
                  userPermission
                );
              }}
            />
          </Link>
        ),
      },
    ],
    [navigate, userPermission, deleteUserDialog, users]
  );

  return (
    <div>
      <Table
        columns={columns}
        data={users}
        searchBy="email"
        label="Pesquise um usuário pelo e-mail"
      />

      <Notification notify={notify} setNotify={setNotify} />

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}
